import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Col, Container, Row, Table, Form, Collapse } from "react-bootstrap";
import LightGallery from "lightgallery/react";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import userRouteMap from "routes/User/userRouteMap";
import { BASE_NAME } from "config";
import ImageElement from "components/ImageElement";
import { removeBordersFromCursorPointerImages } from "utils/helpers";

function FloorPlanCompare() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  
  // Check if private mode is enabled
  const localValue = localStorage.getItem("privateMode");
  const isPrivateMode = localValue === "true";
  
  const CompareFloorPlan = () => {
    navigate(userRouteMap.MEETINGFLOORPLAN.path);
  };
  // table active
  const [activeRow, setActiveRow] = useState(null);
  const handleClick = (index) => {
    setActiveRow(index);
    setActiveRow(activeRow === index ? null : index);
  };

  // light gallery
  const onInit = () => {};

  const handleImageClick = (thisImage) => {
    removeBordersFromCursorPointerImages();
    thisImage.classList.add('bordered');
  }

  return (
    <div className="mainContent_inner floorPlanPage">
      <Container fluid className="position-relative">
        <Link
          className="commonBack commonBack_topLeft text-uppercase d-block h-auto position-absolute"
          onClick={CompareFloorPlan}
        >
          <em className="icon-back" />
          <span className="d-block">Back</span>
        </Link>
        <div className="d-flex justify-content-between  row">
          <Col
            md={6}
            className="imgGrid flex-shrink-0 d-flex flex-column align-items-center pe-lg-5 justify-content-start"
          >
            <div className="imgGrid_inner d-flex flex-column">
              <div>
                <h2 className="imgGrid_title">PH30</h2>
                {isPrivateMode ? (
                  <LightGallery
                    onInit={onInit}
                    elementClassNames="gallery-container row gx-2 gy-2"
                    speed={500}
                    mobileSettings={{
                      controls: true,
                      showCloseIcon: true,
                      download: true,
                    }}
                    plugins={[lgThumbnail, lgZoom]}
                  >
                    <a
                      className="imgGrid_item col-6 col-lg-4"
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-01.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        FLOOR PLAN
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-03.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-04.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-05.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                  </LightGallery>
                ) : (
                  <div className="gallery-container row gx-2 gy-2">
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-01.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        FLOOR PLAN
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                        />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-03.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-04.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-05.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                  </div>
                )}
              </div>
              <div>
                <h2 className="imgGrid_title">15A</h2>
                {isPrivateMode ? (
                  <LightGallery
                    onInit={onInit}
                    elementClassNames="gallery-container row gx-2 gy-2"
                    speed={500}
                    mobileSettings={{
                      controls: true,
                      showCloseIcon: true,
                      download: true,
                    }}
                    plugins={[lgThumbnail, lgZoom]}
                  >
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-01.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        FLOOR PLAN
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/floor-plan-11.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-06.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                    <a
                      href={`${BASE_NAME}/assets/images/screening-room.webp`}
                      className="imgGrid_item col-6 col-lg-4"
                    >
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-07.webp"
                        className="img-fluid"
                        alt="floor-plan"
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </a>
                  </LightGallery>
                ) : (
                  <div className="gallery-container row gx-2 gy-2">
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-01.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        FLOOR PLAN
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid bordered"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-02.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        VIEW
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/floor-plan-11.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-06.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                    <div className="imgGrid_item col-6 col-lg-4 cursor-pointer">
                      <ImageElement
                        imageFor="user"
                        source="floor-plan/plan-07.webp"
                        className="img-fluid"
                        alt="floor-plan"
                        onClick={(e) => handleImageClick(e.currentTarget)}
                      />
                      <h3 className="imgGrid_item_label text-uppercase mt-1">
                        RENDERING
                      </h3>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col
            md={6}
            className="floorPlanSec position-relative d-flex flex-column align-items-center ps-0 "
          >
            <div className="header w-100 d-flex align-items-center pe-1">
              <div className="header_title mx-auto">
                <h1 className="mb-0">Lounge Room</h1>
              </div>
              <Link className="header_logo" to={userRouteMap.LANDING.path}>
                <ImageElement
                  imageFor="user"
                  source="logo.svg"
                  className="img-fluid"
                />
              </Link>
            </div>
            <div className="filterBox position-absolute">
              <div
                onClick={() => setOpen(!open)}
                aria-controls="filter-collapse"
                aria-expanded={open}
                className="filterBox_title"
              >
                FILTERS <em className="icon-arrow-down ms-1" />
              </div>
              <Collapse in={open}>
                <Row>
                  <Col md={12} lg={6}>
                    <div className="filterBox_content">
                      <h2 className="filterBox_content_title">BEDROOM COUNT</h2>
                      <ul className="filterBox_content_list filterBox_content-bedroom  list-unstyled">
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="Suites"
                            label="Suites"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="4-Bedroom"
                            label="4 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="1-Bedroom"
                            label="1 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="5-Bedroom"
                            label="5 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="2-Bedroom"
                            label="2 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="6-Bedroom"
                            label="6 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="3-Bedroom"
                            label="3 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="7-Bedroom"
                            label="7 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                      </ul>
                    </div>
                    <div className="filterBox_content">
                      <h2 className="filterBox_content_title">DUPLEXES</h2>
                      <ul className="filterBox_content_list   list-unstyled">
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="lower-floor-units"
                            label="Lower Floor Units"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="penthouse-units"
                            label="Penthouse Units"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="full-floor-units"
                            label="Full Floor Units Only"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="available-listings"
                            label="Available Listings Only"
                            className="diamond-checkbox"
                          />
                        </li>
                      </ul>
                    </div>
                  </Col>
                  <Col lg={5} md={12} className="offset-lg-1 ps-lg-0 ps-xl-3">
                    <div className="filterBox_content">
                      <h2 className="filterBox_content_title">FEATURES</h2>
                      <ul className="filterBox_content_list features list-unstyled">
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="dual-primary-bathrooms"
                            label="Dual Primary Bathrooms"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="primary-bedroom-view-n"
                            label="Primary Bedroom View: N"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="one-bedroom"
                            label="1 Bedroom"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="primary-bedroom-view-s"
                            label="Primary Bedroom View: S"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="primary-bedroom-view-w"
                            label="Primary Bedroom View: W"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="dining-room"
                            label="Dining Room"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="breakfast-room"
                            label="Breakfast Room"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="eat-in-kitchen"
                            label="Eat-in-Kitchen"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="powder-room"
                            label="Powder Room"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="library-study-office"
                            label="Library (Study/Office)"
                            className="diamond-checkbox"
                          />
                        </li>
                        <li>
                          <Form.Check
                            type="checkbox"
                            id="entertaining-outdoor-space"
                            label="Entertaining Outdoor Space"
                            className="diamond-checkbox"
                          />
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Collapse>
            </div>
            <div className="floorPlanSec_table pe-lg-3">
              <Table hover className="commonTable border-0">
                <thead>
                  <tr>
                    <th>Tower</th>
                    <th>Unit</th>
                    <th>Bed</th>
                    <th>Bath</th>
                    <th>Interior sf</th>
                    <th>Exterior sf</th>
                    <th className="text-center">Fav</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    className={`${activeRow === 0 ? "table-active" : ""}`}
                    onClick={() => handleClick(0)}
                  >
                    <td>W</td>
                    <td>PH30</td>
                    <td>7</td>
                    <td>4 1/2</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 1 ? "table-active" : ""}`}
                    onClick={() => handleClick(1)}
                  >
                    <td>W</td>
                    <td>PH30</td>
                    <td>7</td>
                    <td>4 1/2</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 2 ? "table-active" : ""}`}
                    onClick={() => handleClick(2)}
                  >
                    <td>W</td>
                    <td>PH30</td>
                    <td>7</td>
                    <td>4 1/2</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 3 ? "table-active" : ""}`}
                    onClick={() => handleClick(3)}
                  >
                    <td>W</td>
                    <td>PH30</td>
                    <td>7</td>
                    <td>4 1/2</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 4 ? "table-active" : ""}`}
                    onClick={() => handleClick(4)}
                  >
                    <td>W</td>
                    <td>PH30</td>
                    <td>7</td>
                    <td>4 1/2</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 5 ? "table-active" : ""}`}
                    onClick={() => handleClick(5)}
                  >
                    <td>S</td>
                    <td>12B</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 6 ? "table-active" : ""}`}
                    onClick={() => handleClick(6)}
                  >
                    <td>S</td>
                    <td>12B</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 7 ? "table-active" : ""}`}
                    onClick={() => handleClick(7)}
                  >
                    <td>S</td>
                    <td>12B</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 8 ? "table-active" : ""}`}
                    onClick={() => handleClick(8)}
                  >
                    <td>S</td>
                    <td>12B</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                  <tr
                    className={`${activeRow === 9 ? "table-active" : ""}`}
                    onClick={() => handleClick(9)}
                  >
                    <td>S</td>
                    <td>12B</td>
                    <td>3</td>
                    <td>4</td>
                    <td>4,744 SF</td>
                    <td>1,042 SF</td>
                    <td className="text-center">
                      <Form.Check
                        onClick={(e) => e.stopPropagation()}
                        type="checkbox"
                        className="diamond-checkbox"
                        aria-label="Diamond-shaped checkbox"
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
            {/* <div className="d-flex mt-auto me-auto">
              <div className="customSwitch d-flex align-items-center">
                <label className="switch">
                  <input type="checkbox" defaultChecked />
                  <span className="slider" />
                </label>
                <span className="switchLabel">COMPARE</span>
              </div>
              <div className="clearBtn d-flex align-items-center">
                <em className="icon-close me-3" />
                <span>CLEAR ALL</span>
              </div>
            </div> */}
          </Col>
        </div>
      </Container>
    </div>
  );
}

export default FloorPlanCompare;
